var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',_vm._g(_vm._b({attrs:{"headers":_vm.headers,"item-key":"_id"},scopedSlots:_vm._u([{key:"item.strike",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatCurrency(item.strike))+" ")]}},{key:"item.expirationDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.expirationDate))+" ")]}},{key:"item.quantity",fn:function(ref){
var item = ref.item;
return [_c('span',{class:{ 'error--text': item.quantity < 0 }},[_vm._v(" "+_vm._s(_vm.formatNumber(item.quantity))+" ")])]}},{key:"item.refPrice",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatCurrency(item.refPrice))+" ")]}},{key:"item.totalDeltaExposure",fn:function(ref){
var item = ref.item;
return [_c('span',{class:{ 'error--text': item.totalDeltaExposure < 0 }},[_vm._v(" "+_vm._s(_vm.formatCurrency(item.totalDeltaExposure))+" ")])]}},{key:"item.value",fn:function(ref){
var item = ref.item;
return [_c('span',{class:{ 'error--text': item.value < 0 }},[_vm._v(" "+_vm._s(_vm.formatCurrency(item.value))+" ")])]}},{key:"item.percValue",fn:function(ref){
var item = ref.item;
return [_c('span',{class:{ 'error--text': item.percValue < 0 }},[_vm._v(" "+_vm._s(_vm.formatPercentage(item.percValue))+" ")])]}}])},'v-data-table',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }